import { Navigation } from '../layout/navigation/navigation';
import { AppointmentPage } from '../../pages/appointment-page/appointment-page';
import { ShortcodesPage } from '../../pages/bookr-shortcodes/bookr-shortcodes-page';
import { OpeneingTimesPage } from '../../pages/opening-time-page/opening-time-page';
import { SettingsPage } from '../../pages/settings-page/settings-page';
import { CustomerPage } from '../../pages/customer-page/customer-page';
import { FloatButton } from 'antd';
import { SvgIcon } from '../svg-icon/svg-icon';
import { useTranslation } from 'react-i18next';
import './../../styles.scss';
import './backend-wrapper.scss';

export type PageNames = 'bookr' | 'bookr-opening-time' | 'bookr-customers' | 'bookr-settings' | 'bookr-shortcodes';

export const BackEndWrapper = () => {
	const { t } = useTranslation();

	const renderPage = () => {
		const currentUrl = `${window.location.search}`;
		const menuSlug = currentUrl.split('=')[1];

		switch (menuSlug) {
			case 'bookr-opening-time':
				return <OpeneingTimesPage />;
			case 'bookr-customers':
				return <CustomerPage />;
			case 'bookr-shortcodes':
				return <ShortcodesPage />;
			case 'bookr-settings':
				return <SettingsPage />;
			default:
				return <AppointmentPage />;
		}
	};

	function onClickSupport() {
		location.href = 'mailto:bookr@bssoftware.de?subject=Bookr Support';
	}

	return (
		<>
			<Navigation />
			<div className='bookr-content-wrapper'>
				{renderPage()}
				<FloatButton icon={<SvgIcon name='customerService' size={24} />} tooltip={<div>{t('backEnd.contactSupport')}</div>} onClick={onClickSupport} />
			</div>
		</>
	);
};
